const layouts = path => () => import(`@/layouts/${path}`);
const pages = path => () => import(`@/views/${path}`);
export {layouts, pages};
